// tslint:disable
/**
 * Baufritz Configurator Service
 * The Baufritz Configurator Service provides endpoints and functionality for the configuration of Baufritz smart Green houses. 
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.loose@experienceone.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Contains all customer information to feed the BauFritz CRM so set an appointment. 
 * @export
 * @interface AppointmentRequest
 */
export interface AppointmentRequest {
    /**
     * 
     * @type {Salutation}
     * @memberof AppointmentRequest
     */
    salutation: Salutation;
    /**
     * customers frist name.
     * @type {string}
     * @memberof AppointmentRequest
     */
    firstname: string;
    /**
     * customers last name.
     * @type {string}
     * @memberof AppointmentRequest
     */
    lastname: string;
    /**
     * customers mail address.
     * @type {string}
     * @memberof AppointmentRequest
     */
    mail: string;
    /**
     * part of customers current residential address. Street.
     * @type {string}
     * @memberof AppointmentRequest
     */
    street: string;
    /**
     * part of customers current residential address. House number.
     * @type {string}
     * @memberof AppointmentRequest
     */
    number: string;
    /**
     * part of customers current residential address. Zip code.
     * @type {string}
     * @memberof AppointmentRequest
     */
    zip: string;
    /**
     * part of customers current residential address. City.
     * @type {string}
     * @memberof AppointmentRequest
     */
    city: string;
    /**
     * part of customers current residential address. Country Code.
     * @type {string}
     * @memberof AppointmentRequest
     */
    countryCode: string;
    /**
     * customers phone number
     * @type {string}
     * @memberof AppointmentRequest
     */
    phone?: string;
    /**
     * additional notes
     * @type {string}
     * @memberof AppointmentRequest
     */
    message?: string;
    /**
     * online code for a specific user created house configuration
     * @type {string}
     * @memberof AppointmentRequest
     */
    baufritzCode: string;
    /**
     * validation field
     * @type {string}
     * @memberof AppointmentRequest
     */
    eosum?: string;
    /**
     * 
     * @type {LandStatus}
     * @memberof AppointmentRequest
     */
    landAvailable: LandStatus;
    /**
     * number of the building field
     * @type {string}
     * @memberof AppointmentRequest
     */
    landFieldNumber?: string;
    /**
     * city/location at which the house should be build
     * @type {string}
     * @memberof AppointmentRequest
     */
    landCity?: string;
    /**
     * postal code of the city/location at whith the house should be build
     * @type {string}
     * @memberof AppointmentRequest
     */
    landZip?: string;
    /**
     * 
     * @type {AppointmentType}
     * @memberof AppointmentRequest
     */
    appointmentType: AppointmentType;
}
/**
 * Representation of the appointment type options for the appointment request.
 * @export
 * @enum {string}
 */
export enum AppointmentType {
    CONSULATIONAPPOINTMENT = 'CONSULATION_APPOINTMENT',
    OFFERREQUEST = 'OFFER_REQUEST'
}

/**
 * Payload of configuration requests that holds information about the current selections and the designated configuration update. 
 * @export
 * @interface ConfigurationRequest
 */
export interface ConfigurationRequest {
    /**
     * List of current selections (selected module-zone combination).
     * @type {Array<Selection>}
     * @memberof ConfigurationRequest
     */
    selections: Array<Selection>;
    /**
     * List of designated configuration updates. The list will work as a FIFO queue which means that selections will be handled in the same order as they lie within the list (the first item will be handled first and so on). 
     * @type {Array<Selection>}
     * @memberof ConfigurationRequest
     */
    update?: Array<Selection>;
}
/**
 * Configuration conflict with it causes and possible solutions to fix the conflict.
 * @export
 * @interface Conflict
 */
export interface Conflict {
    /**
     * List of causes for the configuration conflict. These are always selected modules from previous selections. In most cases those selections have to be removed in order to fix the configuration conflict. 
     * @type {Array<ExtendedSelection>}
     * @memberof Conflict
     */
    causes: Array<ExtendedSelection>;
    /**
     * Description for the cause that provides more details about the conflict cause.
     * @type {string}
     * @memberof Conflict
     */
    causesDescription: string;
    /**
     * List of fixes for the configuration conflict.
     * @type {Array<Fix>}
     * @memberof Conflict
     */
    fixes: Array<Fix>;
    /**
     * Description for the cause that provides more details about the conflict fixes.
     * @type {string}
     * @memberof Conflict
     */
    fixesDescription: string;
}
/**
 * An extended selection provides additional informations regarding a selection, e.g. name and thumbnail.
 * @export
 * @interface ExtendedSelection
 */
export interface ExtendedSelection {
    /**
     * 
     * @type {Selection}
     * @memberof ExtendedSelection
     */
    selection: Selection;
    /**
     * Description that provides more details for a conflict cause or fix.
     * @type {string}
     * @memberof ExtendedSelection
     */
    description?: string;
    /**
     * Name of the selections floor.
     * @type {string}
     * @memberof ExtendedSelection
     */
    floorName: string;
    /**
     * Name of the selections zone (optional).
     * @type {string}
     * @memberof ExtendedSelection
     */
    zoneName?: string;
    /**
     * Name of the selections module.
     * @type {string}
     * @memberof ExtendedSelection
     */
    moduleName: string;
    /**
     * URL to the thumbnail image of the house module.
     * @type {string}
     * @memberof ExtendedSelection
     */
    thumbnail: string;
    /**
     * Price of the module. This property is optional.
     * @type {number}
     * @memberof ExtendedSelection
     */
    price?: number;
}
/**
 * Fix for a configuration conflict with an ordered list of steps (configuration changes) to follow in order to solve the conflict. 
 * @export
 * @interface Fix
 */
export interface Fix {
    /**
     * Ordered list of steps (configuration changes) that needs to be followed in order to solve the configuration conflict. 
     * @type {Array<ExtendedSelection>}
     * @memberof Fix
     */
    steps: Array<ExtendedSelection>;
}
/**
 * Representation of a house floor, e.g. basement, ground floor, attic.
 * @export
 * @interface Floor
 */
export interface Floor {
    /**
     * ID of the floor.
     * @type {string}
     * @memberof Floor
     */
    ID: string;
    /**
     * Name of the floor.
     * @type {string}
     * @memberof Floor
     */
    name: string;
    /**
     * Short description of the zone that provides information about the zone itself or important hints for the upcoming configuration process. 
     * @type {string}
     * @memberof Floor
     */
    description: string;
    /**
     * Extended version of the description that provides more detailed information.
     * @type {string}
     * @memberof Floor
     */
    detailedDescription?: string;
    /**
     * List of zone on the floor.
     * @type {Array<Zone>}
     * @memberof Floor
     */
    zones: Array<Zone>;
    /**
     * URL to the image of the house floor.
     * @type {string}
     * @memberof Floor
     */
    image: string;
    /**
     * URLs for additional images of the house floor, e.g. image of the terrace.
     * @type {Array<string>}
     * @memberof Floor
     */
    additionalImages?: Array<string>;
}
/**
 * Summary for the configuration of a house floor.
 * @export
 * @interface FloorSummary
 */
export interface FloorSummary {
    /**
     * Usable and living area of the floor.
     * @type {number}
     * @memberof FloorSummary
     */
    area: number;
    /**
     * Number of rooms on the floor.
     * @type {number}
     * @memberof FloorSummary
     */
    rooms: number;
    /**
     * Selected modules.
     * @type {Array<ModuleSummary>}
     * @memberof FloorSummary
     */
    modules: Array<ModuleSummary>;
    /**
     * Transformation operations for each zone of the house floor.
     * @type {Array<ZoneImageTransformation>}
     * @memberof FloorSummary
     */
    zoneTransformations: Array<ZoneImageTransformation>;
}
/**
 * Representation of the data model for the \'Image Gallery\' and the \'Whistleblower Tool\'. 
 * @export
 * @interface Gallery
 */
export interface Gallery {
    /**
     * List of gallery slides.
     * @type {Array<GallerySlide>}
     * @memberof Gallery
     */
    slides: Array<GallerySlide>;
}
/**
 * Representation of a single slide for the \'Image Gallery\'.
 * @export
 * @interface GallerySlide
 */
export interface GallerySlide {
    /**
     * Compact description of the module features in a significant manner. 
     * @type {string}
     * @memberof GallerySlide
     */
    headline?: string;
    /**
     * Description of the module feature in a significant manner. 
     * @type {string}
     * @memberof GallerySlide
     */
    text?: string;
    /**
     * List of slide images.
     * @type {Array<GallerySlideImage>}
     * @memberof GallerySlide
     */
    images: Array<GallerySlideImage>;
}
/**
 * Representation of an image that will be placed on a gallery slide. 
 * @export
 * @interface GallerySlideImage
 */
export interface GallerySlideImage {
    /**
     * Headline of the image.
     * @type {string}
     * @memberof GallerySlideImage
     */
    headline: string;
    /**
     * URL to the iamge.
     * @type {string}
     * @memberof GallerySlideImage
     */
    image: string;
}
/**
 * Holds information about the current state of the house configuration, possible conflicts and the selected module-zone combinations. 
 * @export
 * @interface HouseConfiguration
 */
export interface HouseConfiguration {
    /**
     * ID of the house type.
     * @type {string}
     * @memberof HouseConfiguration
     */
    typeID: string;
    /**
     * ID of the house size.
     * @type {string}
     * @memberof HouseConfiguration
     */
    sizeID: string;
    /**
     * Total price of the house.
     * @type {number}
     * @memberof HouseConfiguration
     */
    totalPrice: number;
    /**
     * List of available floors.
     * @type {Array<Floor>}
     * @memberof HouseConfiguration
     */
    floors: Array<Floor>;
    /**
     * List of current selections (selected module-zone combination).
     * @type {Array<Selection>}
     * @memberof HouseConfiguration
     */
    selections: Array<Selection>;
    /**
     * Configuration code that represents the current house configuration.
     * @type {string}
     * @memberof HouseConfiguration
     */
    configurationCode: string;
    /**
     * A short form of the configuration code required for share options.
     * @type {string}
     * @memberof HouseConfiguration
     */
    baufritzCode: string;
    /**
     * List of conflicts due to the latest configuration update.
     * @type {Array<Conflict>}
     * @memberof HouseConfiguration
     */
    conflicts?: Array<Conflict>;
    /**
     * URL to the video of the exterior view of the house based on the selected roof.
     * @type {string}
     * @memberof HouseConfiguration
     */
    video: string;
    /**
     * URL to the image of the house (exterior perspective without any configuration details).
     * @type {string}
     * @memberof HouseConfiguration
     */
    houseImage: string;
}
/**
 * Representation of a Baufritz house size.
 * @export
 * @interface HouseSize
 */
export interface HouseSize {
    /**
     * ID of the house size.
     * @type {string}
     * @memberof HouseSize
     */
    ID: string;
    /**
     * Name of the house size.
     * @type {string}
     * @memberof HouseSize
     */
    name: string;
    /**
     * Short description of the zone that provides information about the zone itself or important hints for the upcoming configuration process. 
     * @type {string}
     * @memberof HouseSize
     */
    description: string;
    /**
     * Extended version of the description that provides more detailed information.
     * @type {string}
     * @memberof HouseSize
     */
    detailedDescription?: string;
    /**
     * 
     * @type {Range}
     * @memberof HouseSize
     */
    area: Range;
    /**
     * 
     * @type {Range}
     * @memberof HouseSize
     */
    rooms: Range;
    /**
     * 
     * @type {Range}
     * @memberof HouseSize
     */
    persons: Range;
    /**
     * Price of the house.
     * @type {number}
     * @memberof HouseSize
     */
    price: number;
    /**
     * 
     * @type {HouseConfiguration}
     * @memberof HouseSize
     */
    configuration: HouseConfiguration;
    /**
     * URL to the image of the house (exterior perspective without any configuration details).
     * @type {string}
     * @memberof HouseSize
     */
    image: string;
}
/**
 * Representation of a Baufritz house type.
 * @export
 * @interface HouseType
 */
export interface HouseType {
    /**
     * ID of the house type.
     * @type {string}
     * @memberof HouseType
     */
    ID: string;
    /**
     * Name of the house type.
     * @type {string}
     * @memberof HouseType
     */
    name: string;
}
/**
 * Representation of the land status options for the appointment request.
 * @export
 * @enum {string}
 */
export enum LandStatus {
    BOUGHT = 'BOUGHT',
    EXPECTED = 'EXPECTED',
    RESERVED = 'RESERVED',
    NONE = 'NONE'
}

/**
 * Representation of media assets for a preset.
 * @export
 * @interface Media
 */
export interface Media {
    /**
     * URL to the media asset (image or video) that should be shown on the preset tile. 
     * @type {string}
     * @memberof Media
     */
    url: string;
    /**
     * 
     * @type {MediaType}
     * @memberof Media
     */
    assetType: MediaType;
}
/**
 * Representation of the media asset type options for a preset.
 * @export
 * @enum {string}
 */
export enum MediaType {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO'
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Application error code that identifies the issues application wide.
     * @type {number}
     * @memberof ModelError
     */
    code: number;
    /**
     * Message giving a description about the error.
     * @type {string}
     * @memberof ModelError
     */
    message: string;
    /**
     * Field is optional and will be set in case of validation errors where a certain field (property) of the request data was not set. 
     * @type {string}
     * @memberof ModelError
     */
    field?: string;
}
/**
 * Representation of a module that can be placed within a house zone and is a certain variant of a room, e.g. an open or closed kitchen. 
 * @export
 * @interface Module
 */
export interface Module {
    /**
     * ID of the module.
     * @type {string}
     * @memberof Module
     */
    ID: string;
    /**
     * Name of the module.
     * @type {string}
     * @memberof Module
     */
    name: string;
    /**
     * Description of the module that provides information about the module itself or important hints for the upcoming configuration process. 
     * @type {string}
     * @memberof Module
     */
    description: string;
    /**
     * Extended version of the description that provides more detailed information.
     * @type {string}
     * @memberof Module
     */
    detailedDescription?: string;
    /**
     * Price of the module.
     * @type {number}
     * @memberof Module
     */
    price?: number;
    /**
     * Indicates if the module is selected.
     * @type {boolean}
     * @memberof Module
     */
    isSelected: boolean;
    /**
     * Indicates if the module is disabled due to the buildability logic.
     * @type {boolean}
     * @memberof Module
     */
    isDisabled: boolean;
    /**
     * List of submodules.
     * @type {Array<Module>}
     * @memberof Module
     */
    modules?: Array<Module>;
    /**
     * URL to the image of the house module.
     * @type {string}
     * @memberof Module
     */
    image: string;
    /**
     * URL to the thumbnail image of the house module.
     * @type {string}
     * @memberof Module
     */
    thumbnail: string;
    /**
     * URL to the \'configuration\' image of the house module which is needed for the exterior view of the house.
     * @type {string}
     * @memberof Module
     */
    imageConfiguration: string;
    /**
     * 
     * @type {Gallery}
     * @memberof Module
     */
    gallery?: Gallery;
    /**
     * Unique selling point of the module.
     * @type {string}
     * @memberof Module
     */
    usp: string;
    /**
     * Usable and living area of the module.
     * @type {number}
     * @memberof Module
     */
    area: number;
    /**
     * Number of rooms in the module.
     * @type {number}
     * @memberof Module
     */
    rooms: number;
}
/**
 * Summary of a house module.
 * @export
 * @interface ModuleSummary
 */
export interface ModuleSummary {
    /**
     * Name of the module.
     * @type {string}
     * @memberof ModuleSummary
     */
    name: string;
    /**
     * Unique selling point of the module.
     * @type {string}
     * @memberof ModuleSummary
     */
    usp: string;
    /**
     * Price of the module.
     * @type {number}
     * @memberof ModuleSummary
     */
    price: number;
}
/**
 * Predefined house configuration for a certain house type.
 * @export
 * @interface Preset
 */
export interface Preset {
    /**
     * Configuration code that represents the presets house configuration.
     * @type {string}
     * @memberof Preset
     */
    configurationCode: string;
    /**
     * A short form of the configuration code required for share options.
     * @type {string}
     * @memberof Preset
     */
    baufritzCode: string;
    /**
     * Name of the preset.
     * @type {string}
     * @memberof Preset
     */
    name: string;
    /**
     * Description of the preset.
     * @type {string}
     * @memberof Preset
     */
    description: string;
    /**
     * 
     * @type {Range}
     * @memberof Preset
     */
    area: Range;
    /**
     * 
     * @type {Range}
     * @memberof Preset
     */
    rooms: Range;
    /**
     * 
     * @type {Range}
     * @memberof Preset
     */
    persons: Range;
    /**
     * Price of the house.
     * @type {number}
     * @memberof Preset
     */
    price: number;
    /**
     * 
     * @type {HouseConfiguration}
     * @memberof Preset
     */
    configuration: HouseConfiguration;
    /**
     * Key of the tracking events for the presets.
     * @type {string}
     * @memberof Preset
     */
    tracking: string;
    /**
     * Indicates if the preset symbolizes the indivdiual planning step.
     * @type {boolean}
     * @memberof Preset
     */
    isIndividual: boolean;
    /**
     * 
     * @type {Media}
     * @memberof Preset
     */
    media?: Media;
}
/**
 * Provides an information range, e.g. min and max number of persons for that a house is suitable.
 * @export
 * @interface Range
 */
export interface Range {
    /**
     * Minimum value.
     * @type {number}
     * @memberof Range
     */
    minimum: number;
    /**
     * Maximum value.
     * @type {number}
     * @memberof Range
     */
    maximum: number;
}
/**
 * Representation of salutation options for the appointment request.
 * @export
 * @enum {string}
 */
export enum Salutation {
    MR = 'MR',
    MS = 'MS',
    NONE = 'NONE'
}

/**
 * Module-Zone combination that is or was selected or unselected.
 * @export
 * @interface Selection
 */
export interface Selection {
    /**
     * ID of a zone.
     * @type {string}
     * @memberof Selection
     */
    zoneID: string;
    /**
     * ID of a module.
     * @type {string}
     * @memberof Selection
     */
    moduleID: string;
    /**
     * Indicates whether the module is/was selected or unselected.
     * @type {boolean}
     * @memberof Selection
     */
    isSelected: boolean;
    /**
     * URL to the \'configuration\' image of the house module which is needed for the exterior view of the house.
     * @type {string}
     * @memberof Selection
     */
    imageConfiguration: string;
}
/**
 * Consists of mail receiver and BauFritz (online)-Code 
 * @export
 * @interface ShareRequest
 */
export interface ShareRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareRequest
     */
    receiver: string;
    /**
     * online code for a specific user created house configuration
     * @type {string}
     * @memberof ShareRequest
     */
    baufritzCode: string;
    /**
     * URL with the link to the configurator.
     * @type {string}
     * @memberof ShareRequest
     */
    url: string;
    /**
     * validation field
     * @type {string}
     * @memberof ShareRequest
     */
    eosum?: string;
}
/**
 * Contains status information for request. 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {boolean}
     * @memberof Status
     */
    success: boolean;
    /**
     * in case of success false a message is given that communicates the error
     * @type {string}
     * @memberof Status
     */
    error?: string;
}
/**
 * Summary that gives some extra information about a house configuration.
 * @export
 * @interface Summary
 */
export interface Summary {
    /**
     * 
     * @type {HouseConfiguration}
     * @memberof Summary
     */
    configuration: HouseConfiguration;
    /**
     * 
     * @type {HouseSize}
     * @memberof Summary
     */
    size: HouseSize;
    /**
     * Sorted list of image URLs for building the summary image with the layering engine.
     * @type {Array<string>}
     * @memberof Summary
     */
    images: Array<string>;
    /**
     * 
     * @type {SummaryItem}
     * @memberof Summary
     */
    summarySize: SummaryItem;
    /**
     * 
     * @type {SummaryItem}
     * @memberof Summary
     */
    summaryRoof: SummaryItem;
    /**
     * 
     * @type {SummaryItem}
     * @memberof Summary
     */
    summaryBasement: SummaryItem;
    /**
     * Total price of the house configuration
     * @type {number}
     * @memberof Summary
     */
    price: number;
    /**
     * Extra costs for all modules of the house configuration.
     * @type {number}
     * @memberof Summary
     */
    modulesPrice: number;
    /**
     * 
     * @type {FloorSummary}
     * @memberof Summary
     */
    summaryGroundFloor: FloorSummary;
    /**
     * 
     * @type {FloorSummary}
     * @memberof Summary
     */
    summaryUpperFloor: FloorSummary;
    /**
     * 
     * @type {FloorSummary}
     * @memberof Summary
     */
    summaryAttic?: FloorSummary;
}
/**
 * A summary item holds the name and price of a summary information.
 * @export
 * @interface SummaryItem
 */
export interface SummaryItem {
    /**
     * Name of a certain summary information
     * @type {string}
     * @memberof SummaryItem
     */
    name: string;
    /**
     * Price of a certain summary information
     * @type {number}
     * @memberof SummaryItem
     */
    price: number;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * Application error code that identifies the issues application wide.
     * @type {string}
     * @memberof ValidationError
     */
    code: string;
    /**
     * Message giving a description about the error.
     * @type {string}
     * @memberof ValidationError
     */
    message: string;
    /**
     * Field is optional and will be set in case of validation errors where a certain field (property) of the request data was not set. 
     * @type {string}
     * @memberof ValidationError
     */
    field: string;
}
/**
 * List of errors that occurred during the validation of request data.
 * @export
 * @interface ValidationErrors
 */
export interface ValidationErrors {
    /**
     * Optional message giving a description about the validations.
     * @type {string}
     * @memberof ValidationErrors
     */
    message: string;
    /**
     * List of occurred validation errors.
     * @type {Array<ValidationError>}
     * @memberof ValidationErrors
     */
    errors: Array<ValidationError>;
}
/**
 * Translation vector.
 * @export
 * @interface Vector
 */
export interface Vector {
    /**
     * 
     * @type {number}
     * @memberof Vector
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof Vector
     */
    y: number;
}
/**
 * Represents a set of information regarding the current version of the service.
 * @export
 * @interface Version
 */
export interface Version {
    /**
     * Version number
     * @type {string}
     * @memberof Version
     */
    version: string;
    /**
     * Build time of the service binary
     * @type {string}
     * @memberof Version
     */
    buildTime: string;
    /**
     * Git commit used to build the service binary
     * @type {string}
     * @memberof Version
     */
    gitCommit: string;
    /**
     * Git tag used to build the service binary (could be the tag that is nearest to the used commit)
     * @type {string}
     * @memberof Version
     */
    gitTag: string;
}
/**
 * Representation of a house zone that correspond to a certain room, e.g. kitchen, living room. A zone is either built up by a list of modules or a list of subzones but not both at the same time. 
 * @export
 * @interface Zone
 */
export interface Zone {
    /**
     * ID of the zone.
     * @type {string}
     * @memberof Zone
     */
    ID: string;
    /**
     * Name of the zone.
     * @type {string}
     * @memberof Zone
     */
    name: string;
    /**
     * Short version of the name (needed for navigation panels).
     * @type {string}
     * @memberof Zone
     */
    shortName: string;
    /**
     * Short description of the zone that provides information about the zone itself or important hints for the upcoming configuration process. 
     * @type {string}
     * @memberof Zone
     */
    description: string;
    /**
     * Extended version of the description that provides more detailed information.
     * @type {string}
     * @memberof Zone
     */
    detailedDescription?: string;
    /**
     * List of modules. A zone can either have a list of modules or a list of subzones but not both at the same time. 
     * @type {Array<Module>}
     * @memberof Zone
     */
    modules?: Array<Module>;
    /**
     * List of subzones. A zone can either have a list of modules or a list of subzones but not both at the same time. 
     * @type {Array<Zone>}
     * @memberof Zone
     */
    zones?: Array<Zone>;
    /**
     * Indicates if the zone is deactivated.
     * @type {boolean}
     * @memberof Zone
     */
    isDeactivated: boolean;
}
/**
 * Informations for image transformation operations of a certain zone in the configuration summary.
 * @export
 * @interface ZoneImageTransformation
 */
export interface ZoneImageTransformation {
    /**
     * ID of the zone.
     * @type {string}
     * @memberof ZoneImageTransformation
     */
    zoneID: string;
    /**
     * 
     * @type {Vector}
     * @memberof ZoneImageTransformation
     */
    translation: Vector;
    /**
     * Scale factor.
     * @type {number}
     * @memberof ZoneImageTransformation
     */
    scale: number;
}

/**
 * BABApi - axios parameter creator
 * @export
 */
export const BABApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the BAB PDF.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBAB: async (acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getBAB.');
            }
            const localVarPath = `/bab`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BABApi - functional programming interface
 * @export
 */
export const BABApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the BAB PDF.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBAB(acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await BABApiAxiosParamCreator(configuration).getBAB(acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BABApi - factory interface
 * @export
 */
export const BABApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns the BAB PDF.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBAB(acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<any> {
            return BABApiFp(configuration).getBAB(acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BABApi - object-oriented interface
 * @export
 * @class BABApi
 * @extends {BaseAPI}
 */
export class BABApi extends BaseAPI {
    /**
     * 
     * @summary Returns the BAB PDF.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BABApi
     */
    public getBAB(acceptLanguage: string, xRequestID?: string, options?: any) {
        return BABApiFp(this.configuration).getBAB(acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration: async (code: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getConfiguration.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getConfiguration.');
            }
            const localVarPath = `/configuration/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the PDF of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the PDF of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPDF: async (code: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getPDF.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getPDF.');
            }
            const localVarPath = `/configuration/{code}/pdf`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of house sizes depending on the choosen house type.
         * @summary Returns a list of house sizes.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizes: async (typeID: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeID' is not null or undefined
            if (typeID === null || typeID === undefined) {
                throw new RequiredError('typeID','Required parameter typeID was null or undefined when calling getSizes.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getSizes.');
            }
            const localVarPath = `/types/{typeID}/sizes`
                .replace(`{${"typeID"}}`, encodeURIComponent(String(typeID)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the summary of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the summary of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: async (code: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getSummary.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getSummary.');
            }
            const localVarPath = `/configuration/{code}/summary`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of house types that can be configured. At the beginning of the implementation of the house configurator there will only be one house type available. 
         * @summary Returns a list of house types.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes: async (acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getTypes.');
            }
            const localVarPath = `/types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a house configuration by considering a set of already selected house modules and a new module selection in the configuration. 
         * @summary Evaluates updates of a house configuration.
         * @param {string} typeID ID of a house type.
         * @param {string} sizeID ID of a house size.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ConfigurationRequest} houseConfiguration 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putConfiguration: async (typeID: string, sizeID: string, acceptLanguage: string, houseConfiguration: ConfigurationRequest, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeID' is not null or undefined
            if (typeID === null || typeID === undefined) {
                throw new RequiredError('typeID','Required parameter typeID was null or undefined when calling putConfiguration.');
            }
            // verify required parameter 'sizeID' is not null or undefined
            if (sizeID === null || sizeID === undefined) {
                throw new RequiredError('sizeID','Required parameter sizeID was null or undefined when calling putConfiguration.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling putConfiguration.');
            }
            // verify required parameter 'houseConfiguration' is not null or undefined
            if (houseConfiguration === null || houseConfiguration === undefined) {
                throw new RequiredError('houseConfiguration','Required parameter houseConfiguration was null or undefined when calling putConfiguration.');
            }
            const localVarPath = `/types/{typeID}/sizes/{sizeID}/configuration`
                .replace(`{${"typeID"}}`, encodeURIComponent(String(typeID)))
                .replace(`{${"sizeID"}}`, encodeURIComponent(String(sizeID)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof houseConfiguration !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(houseConfiguration !== undefined ? houseConfiguration : {}) : (houseConfiguration || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseConfiguration>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getConfiguration(code, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the PDF of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the PDF of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPDF(code: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getPDF(code, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a list of house sizes depending on the choosen house type.
         * @summary Returns a list of house sizes.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSizes(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HouseSize>>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getSizes(typeID, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the summary of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the summary of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummary(code: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Summary>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getSummary(code, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a list of house types that can be configured. At the beginning of the implementation of the house configurator there will only be one house type available. 
         * @summary Returns a list of house types.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypes(acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HouseType>>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getTypes(acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates a house configuration by considering a set of already selected house modules and a new module selection in the configuration. 
         * @summary Evaluates updates of a house configuration.
         * @param {string} typeID ID of a house type.
         * @param {string} sizeID ID of a house size.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ConfigurationRequest} houseConfiguration 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putConfiguration(typeID: string, sizeID: string, acceptLanguage: string, houseConfiguration: ConfigurationRequest, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseConfiguration>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).putConfiguration(typeID, sizeID, acceptLanguage, houseConfiguration, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<HouseConfiguration> {
            return ConfigurationApiFp(configuration).getConfiguration(code, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the PDF of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the PDF of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPDF(code: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<any> {
            return ConfigurationApiFp(configuration).getPDF(code, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of house sizes depending on the choosen house type.
         * @summary Returns a list of house sizes.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizes(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<Array<HouseSize>> {
            return ConfigurationApiFp(configuration).getSizes(typeID, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the summary of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
         * @summary Returns the summary of a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(code: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<Summary> {
            return ConfigurationApiFp(configuration).getSummary(code, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of house types that can be configured. At the beginning of the implementation of the house configurator there will only be one house type available. 
         * @summary Returns a list of house types.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<Array<HouseType>> {
            return ConfigurationApiFp(configuration).getTypes(acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a house configuration by considering a set of already selected house modules and a new module selection in the configuration. 
         * @summary Evaluates updates of a house configuration.
         * @param {string} typeID ID of a house type.
         * @param {string} sizeID ID of a house size.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ConfigurationRequest} houseConfiguration 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putConfiguration(typeID: string, sizeID: string, acceptLanguage: string, houseConfiguration: ConfigurationRequest, xRequestID?: string, options?: any): AxiosPromise<HouseConfiguration> {
            return ConfigurationApiFp(configuration).putConfiguration(typeID, sizeID, acceptLanguage, houseConfiguration, xRequestID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
     * @summary Returns a house configuration.
     * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getConfiguration(code, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the PDF of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
     * @summary Returns the PDF of a house configuration.
     * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getPDF(code: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getPDF(code, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of house sizes depending on the choosen house type.
     * @summary Returns a list of house sizes.
     * @param {string} typeID ID of a house type.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getSizes(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getSizes(typeID, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the summary of a house configuration either by a configuration or a baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using the kernel functionality. 
     * @summary Returns the summary of a house configuration.
     * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getSummary(code: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getSummary(code, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of house types that can be configured. At the beginning of the implementation of the house configurator there will only be one house type available. 
     * @summary Returns a list of house types.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getTypes(acceptLanguage: string, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getTypes(acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a house configuration by considering a set of already selected house modules and a new module selection in the configuration. 
     * @summary Evaluates updates of a house configuration.
     * @param {string} typeID ID of a house type.
     * @param {string} sizeID ID of a house size.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {ConfigurationRequest} houseConfiguration 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public putConfiguration(typeID: string, sizeID: string, acceptLanguage: string, houseConfiguration: ConfigurationRequest, xRequestID?: string, options?: any) {
        return ConfigurationApiFp(this.configuration).putConfiguration(typeID, sizeID, acceptLanguage, houseConfiguration, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the current data.yml (content file) which is used by the service. 
         * @summary Returns current content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentData: async (xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentLocalization: async (xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/localization`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a new content file and replaces the current data.yml. It also swaps out the current data content used by the service with the new data content. 
         * @summary Uploads content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [dataFile] The data file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentData: async (xRequestID?: string, dataFile?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/data`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


            if (dataFile !== undefined) { 
                localVarFormParams.append('dataFile', dataFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentLocalization: async (xRequestID?: string, localizationFile?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/localization`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


            if (localizationFile !== undefined) { 
                localVarFormParams.append('localizationFile', localizationFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns the current data.yml (content file) which is used by the service. 
         * @summary Returns current content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentData(xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ContentApiAxiosParamCreator(configuration).getContentData(xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentLocalization(xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ContentApiAxiosParamCreator(configuration).getContentLocalization(xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Uploads a new content file and replaces the current data.yml. It also swaps out the current data content used by the service with the new data content. 
         * @summary Uploads content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [dataFile] The data file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContentData(xRequestID?: string, dataFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentApiAxiosParamCreator(configuration).postContentData(xRequestID, dataFile, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentApiAxiosParamCreator(configuration).postContentLocalization(xRequestID, localizationFile, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns the current data.yml (content file) which is used by the service. 
         * @summary Returns current content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentData(xRequestID?: string, options?: any): AxiosPromise<any> {
            return ContentApiFp(configuration).getContentData(xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentLocalization(xRequestID?: string, options?: any): AxiosPromise<any> {
            return ContentApiFp(configuration).getContentLocalization(xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a new content file and replaces the current data.yml. It also swaps out the current data content used by the service with the new data content. 
         * @summary Uploads content file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [dataFile] The data file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentData(xRequestID?: string, dataFile?: any, options?: any): AxiosPromise<void> {
            return ContentApiFp(configuration).postContentData(xRequestID, dataFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any): AxiosPromise<void> {
            return ContentApiFp(configuration).postContentLocalization(xRequestID, localizationFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * Returns the current data.yml (content file) which is used by the service. 
     * @summary Returns current content file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getContentData(xRequestID?: string, options?: any) {
        return ContentApiFp(this.configuration).getContentData(xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current localization.yml (localization file) which is used by the service. 
     * @summary Returns current localization file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getContentLocalization(xRequestID?: string, options?: any) {
        return ContentApiFp(this.configuration).getContentLocalization(xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a new content file and replaces the current data.yml. It also swaps out the current data content used by the service with the new data content. 
     * @summary Uploads content file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {any} [dataFile] The data file that should be uploaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public postContentData(xRequestID?: string, dataFile?: any, options?: any) {
        return ContentApiFp(this.configuration).postContentData(xRequestID, dataFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
     * @summary Uploads localization file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {any} [localizationFile] The localization file that should be uploaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any) {
        return ContentApiFp(this.configuration).postContentLocalization(xRequestID, localizationFile, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new appoint as part of the configuration process.
         * @summary Creates a new appointment.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {AppointmentRequest} appointment 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppointment: async (acceptLanguage: string, appointment: AppointmentRequest, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling postAppointment.');
            }
            // verify required parameter 'appointment' is not null or undefined
            if (appointment === null || appointment === undefined) {
                throw new RequiredError('appointment','Required parameter appointment was null or undefined when calling postAppointment.');
            }
            const localVarPath = `/customer/appointment`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof appointment !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(appointment !== undefined ? appointment : {}) : (appointment || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shares BauFritz code via E-Mail using own SMTP.
         * @summary Shares BauFritz code via E-Mail.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ShareRequest} mailShare 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShare: async (acceptLanguage: string, mailShare: ShareRequest, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling postShare.');
            }
            // verify required parameter 'mailShare' is not null or undefined
            if (mailShare === null || mailShare === undefined) {
                throw new RequiredError('mailShare','Required parameter mailShare was null or undefined when calling postShare.');
            }
            const localVarPath = `/customer/share`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof mailShare !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(mailShare !== undefined ? mailShare : {}) : (mailShare || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new appoint as part of the configuration process.
         * @summary Creates a new appointment.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {AppointmentRequest} appointment 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppointment(acceptLanguage: string, appointment: AppointmentRequest, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await CustomerApiAxiosParamCreator(configuration).postAppointment(acceptLanguage, appointment, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Shares BauFritz code via E-Mail using own SMTP.
         * @summary Shares BauFritz code via E-Mail.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ShareRequest} mailShare 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postShare(acceptLanguage: string, mailShare: ShareRequest, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await CustomerApiAxiosParamCreator(configuration).postShare(acceptLanguage, mailShare, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a new appoint as part of the configuration process.
         * @summary Creates a new appointment.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {AppointmentRequest} appointment 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppointment(acceptLanguage: string, appointment: AppointmentRequest, xRequestID?: string, options?: any): AxiosPromise<Status> {
            return CustomerApiFp(configuration).postAppointment(acceptLanguage, appointment, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Shares BauFritz code via E-Mail using own SMTP.
         * @summary Shares BauFritz code via E-Mail.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {ShareRequest} mailShare 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShare(acceptLanguage: string, mailShare: ShareRequest, xRequestID?: string, options?: any): AxiosPromise<Status> {
            return CustomerApiFp(configuration).postShare(acceptLanguage, mailShare, xRequestID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * Creates a new appoint as part of the configuration process.
     * @summary Creates a new appointment.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {AppointmentRequest} appointment 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public postAppointment(acceptLanguage: string, appointment: AppointmentRequest, xRequestID?: string, options?: any) {
        return CustomerApiFp(this.configuration).postAppointment(acceptLanguage, appointment, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shares BauFritz code via E-Mail using own SMTP.
     * @summary Shares BauFritz code via E-Mail.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {ShareRequest} mailShare 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public postShare(acceptLanguage: string, mailShare: ShareRequest, xRequestID?: string, options?: any) {
        return CustomerApiFp(this.configuration).postShare(acceptLanguage, mailShare, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PresetApi - axios parameter creator
 * @export
 */
export const PresetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration: async (code: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getConfiguration.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getConfiguration.');
            }
            const localVarPath = `/configuration/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retruns a list of predefined house configurations.
         * @summary Returns a list of presets.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresets: async (typeID: string, acceptLanguage: string, xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeID' is not null or undefined
            if (typeID === null || typeID === undefined) {
                throw new RequiredError('typeID','Required parameter typeID was null or undefined when calling getPresets.');
            }
            // verify required parameter 'acceptLanguage' is not null or undefined
            if (acceptLanguage === null || acceptLanguage === undefined) {
                throw new RequiredError('acceptLanguage','Required parameter acceptLanguage was null or undefined when calling getPresets.');
            }
            const localVarPath = `/types/{typeID}/presets`
                .replace(`{${"typeID"}}`, encodeURIComponent(String(typeID)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PresetApi - functional programming interface
 * @export
 */
export const PresetApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseConfiguration>> {
            const localVarAxiosArgs = await PresetApiAxiosParamCreator(configuration).getConfiguration(code, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retruns a list of predefined house configurations.
         * @summary Returns a list of presets.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresets(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Preset>>> {
            const localVarAxiosArgs = await PresetApiAxiosParamCreator(configuration).getPresets(typeID, acceptLanguage, xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PresetApi - factory interface
 * @export
 */
export const PresetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
         * @summary Returns a house configuration.
         * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<HouseConfiguration> {
            return PresetApiFp(configuration).getConfiguration(code, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retruns a list of predefined house configurations.
         * @summary Returns a list of presets.
         * @param {string} typeID ID of a house type.
         * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresets(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any): AxiosPromise<Array<Preset>> {
            return PresetApiFp(configuration).getPresets(typeID, acceptLanguage, xRequestID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PresetApi - object-oriented interface
 * @export
 * @class PresetApi
 * @extends {BaseAPI}
 */
export class PresetApi extends BaseAPI {
    /**
     * Returns a house configuration for either a configuration or baufritz code. If the house configuration isn\'t valid anymore due to updates of the available house configuration options than the service will try to heal the configuration by using certain kernel functionality. 
     * @summary Returns a house configuration.
     * @param {string} code Could be either the configuration or the baufritz code of a house configuration.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetApi
     */
    public getConfiguration(code: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return PresetApiFp(this.configuration).getConfiguration(code, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retruns a list of predefined house configurations.
     * @summary Returns a list of presets.
     * @param {string} typeID ID of a house type.
     * @param {string} acceptLanguage Locale code that combines out of &lt;language&gt;-&lt;country&gt;. For the language the ISO-639-1 standard will be used and for the country the ISO-3166-1 Alpha-2 standard. 
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetApi
     */
    public getPresets(typeID: string, acceptLanguage: string, xRequestID?: string, options?: any) {
        return PresetApiFp(this.configuration).getPresets(typeID, acceptLanguage, xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentLocalization: async (xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/localization`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current service status.
         * @summary Returns service status
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/status`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns information about the current service version.
         * @summary Returns service version information.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion: async (xRequestID?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/version`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentLocalization: async (xRequestID?: string, localizationFile?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/content/localization`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarRequestOptions["auth"] = { username: configuration.username, password: configuration.password };
            }

            if (xRequestID !== undefined && xRequestID !== null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }


            if (localizationFile !== undefined) { 
                localVarFormParams.append('localizationFile', localizationFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentLocalization(xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await SystemApiAxiosParamCreator(configuration).getContentLocalization(xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the current service status.
         * @summary Returns service status
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SystemApiAxiosParamCreator(configuration).getStatus(xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns information about the current service version.
         * @summary Returns service version information.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersion(xRequestID?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Version>> {
            const localVarAxiosArgs = await SystemApiAxiosParamCreator(configuration).getVersion(xRequestID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SystemApiAxiosParamCreator(configuration).postContentLocalization(xRequestID, localizationFile, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns the current localization.yml (localization file) which is used by the service. 
         * @summary Returns current localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentLocalization(xRequestID?: string, options?: any): AxiosPromise<any> {
            return SystemApiFp(configuration).getContentLocalization(xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current service status.
         * @summary Returns service status
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(xRequestID?: string, options?: any): AxiosPromise<void> {
            return SystemApiFp(configuration).getStatus(xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns information about the current service version.
         * @summary Returns service version information.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion(xRequestID?: string, options?: any): AxiosPromise<Version> {
            return SystemApiFp(configuration).getVersion(xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
         * @summary Uploads localization file.
         * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
         * @param {any} [localizationFile] The localization file that should be uploaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any): AxiosPromise<void> {
            return SystemApiFp(configuration).postContentLocalization(xRequestID, localizationFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Returns the current localization.yml (localization file) which is used by the service. 
     * @summary Returns current localization file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getContentLocalization(xRequestID?: string, options?: any) {
        return SystemApiFp(this.configuration).getContentLocalization(xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current service status.
     * @summary Returns service status
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getStatus(xRequestID?: string, options?: any) {
        return SystemApiFp(this.configuration).getStatus(xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns information about the current service version.
     * @summary Returns service version information.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public getVersion(xRequestID?: string, options?: any) {
        return SystemApiFp(this.configuration).getVersion(xRequestID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a new localization file and replaces the current localization.yml. It also swaps out the current localization content used by the service with the new localization content. 
     * @summary Uploads localization file.
     * @param {string} [xRequestID] The X-Request-ID is an optional header used for tracing the requests journey through the system. When sent it should follow the format of an UUID in version 4. 
     * @param {any} [localizationFile] The localization file that should be uploaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public postContentLocalization(xRequestID?: string, localizationFile?: any, options?: any) {
        return SystemApiFp(this.configuration).postContentLocalization(xRequestID, localizationFile, options).then((request) => request(this.axios, this.basePath));
    }

}


